// extracted by mini-css-extract-plugin
export default {"slider":"wzTKuHplmR2bGDeDkRSf","showFocus":"fCqZA4sUAW7WngEY3r5w","bounce":"KO38h_SK0MHm1hOsUd6_"};